__turbopack_context__.v({
  "error": "jODqIG_error",
  "icon": "jODqIG_icon",
  "labelRow": "jODqIG_labelRow",
});
